import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'
import { Button } from '../Buttons'

export const AlertWrapper = styled.div`
  background-color: ${myPalette.red['100']};
  color: ${myPalette.red['600']};
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 16px;
`

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${myPalette.red['600']};
`

export const ReloadButton = styled(Button)`
  width: 81px;
  height: 31px;
  font-size: 13px;
`
